const comments = [
  {
    name: '夜幕旅人',
    date: '2小时前',
    text: '一直用妖精视频追红桃系列的更新，画质真的没得说，加载速度也快。比之前用的几个平台稳定多了，推荐给喜欢数字颜色系列的朋友。',
    tag: '红桃视频',
  },
  {
    name: '城市观察者',
    date: '5小时前',
    text: '小蓝视频的经典合集修复版太良心了！老片也有高清画质，这个必须给好评。91视频风格的新专题也很有看头，每天蹲更新。',
    tag: '小蓝视频',
  },
  {
    name: '午夜放映厅',
    date: '1天前',
    text: '黑桃视频连载追了快半年了，这个平台更新最准时。97视频的4K片源真的清晰，电视投屏看体验感拉满，周末宅家必备。',
    tag: '黑桃视频',
  },
  {
    name: '光影收藏家',
    date: '2天前',
    text: '从久久视频那边过来的老用户，妖精这边片库全、分类清晰、没有乱七八糟的广告，这才是一个好平台该有的样子。已安利同事。',
    tag: '久久视频',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-14 md:py-20 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-primary-400 font-medium tracking-wider uppercase mb-2">Reviews</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">用户心声</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">来自妖精视频数字颜色系列观众的真实反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-800/40 border border-background-700/30 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center text-primary-400 text-sm font-bold">
                  {comment.name.charAt(0)}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground-200">{comment.name}</p>
                  <p className="text-xs text-foreground-600">{comment.date}</p>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500/10 text-accent-400 whitespace-nowrap">{comment.tag}</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-1 mt-3 text-accent-400">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}